module.exports = __webpack_public_path__ + "static/space-earth.3ab62366.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/schools/space-earth.jpg
// module id = 505
// module chunks = 240366623535745